/**
 *
 * MapComponent
 *
 */

import React, { memo, useEffect, useRef, useState } from "react";
import { usePlacesWidget } from "react-google-autocomplete";

import { Alert, Col, Form, Input } from "antd";
import { googleApiKey } from "../../../utils/constants";
import { MdLocationPin } from "react-icons/md";
import axios from "axios";
import { t } from "i18next";

const {
  SearchBox,
} = require("react-google-maps/lib/components/places/SearchBox");

const getCenterMap = (lat, lng, onHandleMap) => {
  let Templat = 46.29766919163871;
  let Templng = 7.054721282984308;

  if (!isNaN(lat)) {
    Templat = lat;
  }
  if (!isNaN(lng)) {
    Templng = lng;
  }

  return { lat: lat, lng: lng };
};

function AutoCompleteCustom({
  onPlaceSelected,
  item,
  placeholder,
  disabled,
  refForm,
  onChange = () => {},
}) {
  const inputRef = useRef(null);

  const watchedValue = item.name ? Form.useWatch(item.name) : null;

  const antInputRef = useRef(null);

  const [value, setValue] = useState(item.value);
  const [place, setPlace] = useState(null);

  const [refs, setRefs] = useState({});

  const setRefInput = ref => {
    refs.searchBox = ref;
  };

  const onPlaceChanged = e => {
    const place = refs.searchBox.getPlace();

    const address = place.address_components.reduce(
      (seed, { long_name, types }) => {
        types.forEach(t => {
          seed[t] = long_name;
        });

        return seed;
      },
      {},
    );
    onPlaceSelected(place, address);
  };

  const { ref: antRef } = usePlacesWidget({
    apiKey: googleApiKey,
    onPlaceSelected: place => {
      setPlace(place);


      refForm?.current?.setFieldValue(
        "lat_" + item.name,
        place.geometry.location.lat(),
      );
      refForm?.current?.setFieldValue(
        "lng_" + item.name,
        place.geometry.location.lng(),
      );

      const canton = place.address_components.find(component =>
        component?.types?.includes("administrative_area_level_1"),
      );

      refForm?.current?.setFieldValue("canton_" + item.name, canton.short_name);

      // const all = refForm.current.getFieldsValue(true);
      //

      antInputRef.current.input.value = place?.formatted_address;
      antRef.current.value = place?.formatted_address;
      refForm?.current?.setFieldValue(item.name, place?.formatted_address);
      refForm?.current?.setFieldValue("_" + item.name, place);
      // setValue(place?.formatted_address);
      onPlaceSelected(place, place?.formatted_address);
    },
    options: {
      types: ["address"],
      componentRestrictions: { country: "ch" },
    },
  });

  useEffect(() => {
    const getPlaceData = async () => {
      const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
        watchedValue,
      )}&key=${googleApiKey}`;
      const response = await axios.get(url);


      const data = response.data;
      if (data.results.length > 0) {
        setPlace(data.results[0]);
      }
    };

    if (watchedValue !== undefined) {
      antRef.current.value = watchedValue;
      antInputRef.current.input.value = watchedValue;
      setValue(watchedValue);
    }

    if (watchedValue !== undefined || watchedValue !== "") {
      // getPlaceData();
      // TODO 06.03.24 Remove call for number issue until we optimize this @MICKAEL
    } else {
      setPlace(null);
    }
  }, [watchedValue]);

  const renderPlaceAlert = () => {
    if (place !== null) {
      const number = place?.address_components?.find(component =>
        component?.types?.includes("street_number"),
      );
      if (number === undefined) {
        return (
          <Alert
            message={t("form.rueError")}
            type="warning"
            showIcon
            style={{ marginTop: 8 }}
            closable={true}
          />
        );
      }
    }
  };

  return (
    <div>
      <Col key={item.name} span={24} md={24} xs={24} offset={0}>
        <Input
          addonBefore={<MdLocationPin />}
          placeholder={placeholder}
          disabled={disabled}
          onChange={e => {
            setValue(e.target.value);
            // onChange(e.target.value);
          }}
          onBlur={e => {
            let dataForm = refForm?.current?.getFieldValue(
              item.name,
              place?.formatted_address,
            );
            setValue(dataForm);
          }}
          value={value}
          name={item.name}
          ref={c => {
            antInputRef.current = c;
            if (c) antRef.current = c.input;
          }}
        />
        <br />

        {renderPlaceAlert()}
      </Col>
    </div>
  );
}

AutoCompleteCustom.propTypes = {};

export default memo(AutoCompleteCustom);
